import { defineStore } from 'pinia'
import { computed } from 'vue'
import { useNuxtApp } from '#app'
import { useSyncData } from '@/composables/useSyncData'
import { useAuthStore } from '@/stores/useAuthStore'
import type { DiscountModel } from '@/_api/models/discountModel'

export const useDiscountModelStore = defineStore('discountModel', () => {
  const { $api, $grants } = useNuxtApp()
  const authStore = useAuthStore()

  const accountId = computed(() => authStore.activeGuid)

  const {
    items,
    count,
    hydrated,
    syncState,
    isSyncing,
    syncProgress,
    sync: _sync,
    findById,
  } = useSyncData<DiscountModel>({
    service: $api.discountModel,
    key: 'discountModel',
    accountId,
    grants: { discountModel: ['view'] },
  })

  const sync = async (options?: { force?: boolean; change?: boolean }) => {
    if (!$grants.all({ discountModel: ['view'] })) {
      return
    }

    await _sync(options)
  }

  const all = computed(() => items.value)
  const syncDate = computed(() => syncState.value.date)

  return {
    items,
    count,
    hydrated,
    syncState,
    isSyncing,
    syncProgress,
    syncDate,
    sync,
    findById,
    all,
  }
})
